<div class="card mb-3" [formGroup]="formGroup">
    <div class="card-body">
        <div class="card-title">
            <h5>{{ 'utilities_latest_event' | translate }}</h5>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <app-input-date-group
                    [label]="'reporting_START_DATE' | translate"
                    [required]="true"
                    formControlName="startDate" />
            </div>
            <div class="col-md-6 col-sm-12">
                <app-input-date-group
                    [label]="'reporting_END_DATE' | translate"
                    [required]="true"
                    formControlName="endDate" />
                <app-control-messages [control]="formGroup"></app-control-messages>
            </div>
        </div>
        @if (view$ | async; as view) {
            <app-events
                [header]="'utilities_TABLE_CRITICAL' | translate"
                [eventAlarms]="view.critical"
                [metaData]="view.metaData"></app-events>
            <br />
            <app-events
                [header]="'common_warning' | translate: 'online' : 'common'"
                [eventAlarms]="view.warning"
                [metaData]="view.metaData"></app-events>
            <br />
            <app-events
                [header]="'utilities_INFO' | translate"
                [eventAlarms]="view.info"
                [metaData]="view.metaData"></app-events>
        }
    </div>
</div>
